import { BOOKSY } from './constants';

// Simple, tasteful Book Now anchor (single Bray location — no branch tooltip needed).
export const BookNowButton = ({ className, children, testId }) => (
  <a
    href={BOOKSY}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
    data-testid={testId}
  >
    {children}
  </a>
);
